import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_HEADERS, ENDPOINTS } from "../../constants/api";
import { baseQueryWithAuthCheck } from "./helper";
import { callFromMiddleware } from "../../utils";

const baseQuery = fetchBaseQuery({
  baseUrl: window.location.origin,
  headers: API_HEADERS,
  credentials: "include",
});

export const questionnaireApi = createApi({
  reducerPath: "questionnaire",
  baseQuery: baseQueryWithAuthCheck(baseQuery),
  endpoints: (builder) => ({
    getQuestionnaireList: builder.query<any,any>({
      query: () => ({
        url: `${callFromMiddleware(ENDPOINTS.getQuestionaireList)}`,
        method: "GET",
        headers: API_HEADERS,
      }),
    }),
    deleteQuestionnaire: builder.query<any,any>({
      query: (args) => ({
        url: `${callFromMiddleware(ENDPOINTS.deleteQuestionaire)}?questionnaireId=${args.questionnaireId}&enabled=${args.enabled}`,
        method: "GET",
        headers: API_HEADERS,
      }),
    }),
    mappedQuestionaireToJob: builder.query<any,any>({
      query: (args) => ({
        url: `${callFromMiddleware(ENDPOINTS.mappedQuestionaireToJob)}`,
        method: "GET",
        headers: API_HEADERS,
      }),
    }),
    createQuestionnaire: builder.query<any,any>({
      query: (body) => ({
        url: `${callFromMiddleware(ENDPOINTS.createQuestionnaire)}`,
        method: "POST",
        headers: API_HEADERS,
        body:body
      }),
    }),
    attachQuestionnaire: builder.query<any,any>({
      query: (body) => ({
        url: `${callFromMiddleware(ENDPOINTS.attachQuestionnaire)}`,
        method: "POST",
        headers: API_HEADERS,
        body:body
      }),
    }),
    getQuestionnaireJobList: builder.query<any,any>({
      query: (args) => ({
        url: `${callFromMiddleware(ENDPOINTS.getQuestionnaireJobList)}?questionnaireId=${args.questionnaireId}`,
        method: "GET",
        headers: API_HEADERS,
      }),
    }),
    fetchQuestionnaire: builder.query<any,any>({
      query: (args) => ({
        url: `${callFromMiddleware(ENDPOINTS.fetchQuestionnaire)}?questionnaireId=${args.questionnaireId}`,
        method: "GET",
        headers: API_HEADERS,
      }),
    }),
    updateQuestionnaire: builder.query<any,any>({
      query: (body) => ({
        url: `${callFromMiddleware(ENDPOINTS.fetchQuestionnaire)}`,
        method: "POST",
        headers: API_HEADERS,
        body:body
      }),
    }),
}),
});

export const {
 useGetQuestionnaireListQuery, 
 useLazyGetQuestionnaireListQuery,
 useLazyDeleteQuestionnaireQuery,
 useMappedQuestionaireToJobQuery,
 useLazyCreateQuestionnaireQuery,
 useLazyAttachQuestionnaireQuery,
 useLazyGetQuestionnaireJobListQuery,
 useLazyFetchQuestionnaireQuery,
 useLazyUpdateQuestionnaireQuery
} = questionnaireApi;

export default questionnaireApi;